/**
 * 땅주인 로그인 페이지 (/owner/login)
 */
import { useState, type FormEvent } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";
import { usePageTitle } from "../../hooks/usePageTitle";
import { AppHeader } from "../../components/AppHeader";
import { AppFooter } from "../../components/AppFooter";
import { ownerApiFetchPublic } from "../../utils/ownerApi";

export function OwnerLoginPage() {
  usePageTitle("땅주인 로그인");
  const navigate = useNavigate();
  const m = useIsMobile();

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const data = await ownerApiFetchPublic("/api/owner/login", {
        method: "POST",
        body: JSON.stringify({ phone: phone.replace(/\D/g, ""), password }),
      });
      localStorage.setItem("owner_token", data.token);
      localStorage.setItem("owner_info", JSON.stringify(data.owner));
      navigate("/owner/register", { replace: true });
    } catch (err: any) {
      setError(err.message || "로그인에 실패했습니다");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" as const, background: "var(--bg-primary)" }}>
      <AppHeader />
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 16px" }}>
        <div style={{
          width: "100%",
          maxWidth: 420,
          background: "var(--bg-card)",
          border: "1px solid var(--border-light)",
          borderTop: "3px solid var(--lt-gold)",
          borderRadius: "var(--radius-xl)",
          padding: m ? "28px 20px" : "36px 32px",
          boxShadow: "var(--shadow-lg)",
        }}>
          <h2 style={{ margin: "0 0 6px", fontSize: 22, fontWeight: 800, color: "var(--text-primary)" }}>
            {"🌱"} 땅주인 로그인
          </h2>
          <p style={{ margin: "0 0 24px", fontSize: 13, color: "var(--text-muted)" }}>
            땅주인 전용 로그인 화면입니다
          </p>

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" as const, gap: 14 }}>
            <div>
              <label style={{ display: "block", fontSize: 14, fontWeight: 500, color: "var(--text-secondary)", marginBottom: 6 }}>휴대폰 번호</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="010-0000-0000"
                required
                style={{ padding: "12px 14px", borderRadius: "var(--radius-md)", border: "1px solid var(--border-medium)", background: "var(--bg-secondary)", color: "var(--text-primary)", fontSize: 16, width: "100%", boxSizing: "border-box" as const, outline: "none" }}
              />
            </div>
            <div>
              <label style={{ display: "block", fontSize: 14, fontWeight: 500, color: "var(--text-secondary)", marginBottom: 6 }}>비밀번호</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="비밀번호 입력"
                required
                style={{ padding: "12px 14px", borderRadius: "var(--radius-md)", border: "1px solid var(--border-medium)", background: "var(--bg-secondary)", color: "var(--text-primary)", fontSize: 16, width: "100%", boxSizing: "border-box" as const, outline: "none" }}
              />
            </div>
            {error && <p style={{ color: "var(--lt-red)", fontSize: 13, margin: 0, padding: "8px 12px", background: "rgba(239,68,68,0.08)", borderRadius: "var(--radius-md)" }}>{error}</p>}
            <button
              type="submit"
              disabled={loading}
              style={{ padding: "14px", borderRadius: "var(--radius-md)", border: "none", background: "linear-gradient(135deg,#B8972E,#D4AF37)", color: "#0F172A", fontSize: 16, fontWeight: 700, cursor: "pointer", opacity: loading ? 0.6 : 1, marginTop: 4 }}
            >
              {loading ? "로그인 중..." : "로그인"}
            </button>
          </form>

          <p style={{ textAlign: "center" as const, fontSize: 14, color: "var(--text-muted)", marginTop: 20 }}>
            계정이 없으신가요?{" "}
            <Link to="/signup" style={{ color: "var(--lt-gold)", fontWeight: 600, textDecoration: "none" }}>
              땅주인으로 가입
            </Link>
          </p>
        </div>
      </div>
      <AppFooter />
    </div>
  );
}
